module.exports = __webpack_public_path__ + "img/company-name.97da590c.svg";